<template>
  <div
    class="d-flex align-items-stretch justify-content-start flex-wrap"
    :class="{
      'tabs-loading': state.isLoading
    }"
  >
    <DashboardTabListItem
      v-for="tab in availableTableTabs"
      :key="tab.value"
      :label="tab.label"
      :icon="tab.icon"
      :type="tab.type"
      :value="tab.value"
      :tab-class="tab.class"
      :count="tab.count"
      :is-active="activePassType === tab.value"
      :stats="stats"
      @on-tab-click="setActivePassType"
    />
  </div>
</template>

<script>
import passConstants from "@/constants/passConstants"
import DashboardTabListItem from "@/v3components/Datatables/DashboardDataTable/TabsAndFilter/DashboardTabListItem.vue"
import { computed, onMounted, reactive, watch } from "vue"
import { useToast } from "vue-toastification"
import { useStore } from "vuex"

export default {
  name: "DashboardTabsOld",
  components: {
    DashboardTabListItem
  },
  setup() {
    const toast = useToast()
    const store = useStore()

    const state = reactive({
      isLoading: true,
      tableTabs: [
        {
          label: "<b>My<br></b> Passes",
          icon: "flaticon-dashboard_user",
          type: "pass",
          value: "my",
          class: "pass-tabs"
        },
        {
          label: "<b>All<br></b> Passes",
          icon: "flaticon-dashboard_customer",
          type: "pass",
          value: "all",
          class: "pass-tabs"
        },
        {
          label: "Today's Appointments",
          type: "appointments",
          value: "appointments_today",
          class: "purple pass-tabs",
          count: "todayAppointmentsCount"
        },
        {
          label: "Today's Awaiting Confirmation",
          type: "appointments",
          value: "appointments_awaiting",
          class: "red pass-tabs",
          count: "awaitingTodayAppointmentsCount"
        },
        {
          label: "Future Awaiting Confirmation",
          type: "appointments",
          value: "appointments_future_awaiting",
          class: "green pass-tabs",
          count: "futureAppointmentsCount"
        }
      ]
    })

    const isActiveAppoinmentModule = computed(
      () => store.getters["schools/isActiveAppoinmentModule"]
    )
    const activeSchoolHasAppoitmentPasses = computed(
      () => store.getters["schools/activeSchoolHasAppoitmentPasses"]
    )
    const activePassType = computed(
      () => store.getters["dashboardTable/getType"]
    )
    const isAppointmentsCountersFetched = computed(
      () =>
        store?.getters?.["dashboardCounters/isAppointmentsCountersFetched"] ||
        false
    )
    const appTodays = computed(
      () => store?.getters?.["dashboardCounters/appTodays"] || 0
    )
    const appTodaysWaiting = computed(
      () => store?.getters?.["dashboardCounters/appTodaysWaiting"] || 0
    )
    const appFutureWaiting = computed(
      () => store?.getters?.["dashboardCounters/appFutureWaiting"] || 0
    )
    const aptPassesCounters = computed(
      () => store.getters["dashboardCounters/aptPassesCounters"]
    )
    const globalTime = computed(() => store.getters["layout/globalTime"])
    const isUserInTransparency = computed(
      () => store.getters["authentication/isUserInTransparency"]
    )

    const fetchDashboardCounters = async () => {
      try {
        state.isLoading = true
        await store.dispatch("dashboardCounters/getAppointmentMetricsCount")
        store.dispatch("dashboardCounters/getAppointmentsCounters")
      } catch (error) {
        toast.error(
          "Shucks! Something went wrong while we were fetching appointment pass details."
        )
      } finally {
        state.isLoading = false
      }
    }

    onMounted(async () => {
      const type = store.getters["dashboardTable/getType"]
      if (
        !window.localStorage.getItem(
          passConstants.LOCAL_STORAGE_KEYS.DASHBOARD_PASS_TYPE
        ) ||
        type == "appointment" ||
        (!isActiveAppoinmentModule.value && type !== "my" && type !== "all")
      ) {
        window.localStorage.setItem(
          passConstants.LOCAL_STORAGE_KEYS.DASHBOARD_PASS_TYPE,
          "my"
        )
        store.commit("dashboardTable/UPDATE_TYPE", "my")
      }

      if (isActiveAppoinmentModule.value) {
        await fetchDashboardCounters()
      }
    })

    const appointmentMetrics = computed(() => {
      return store?.getters["dashboardCounters/appointmentMetrics"] || {}
    })

    const stats = computed(() => {
      const todayAppointmentsCount = isAppointmentsCountersFetched.value
        ? appTodays.value
        : appointmentMetrics?.value?.today || 0
      const awaitingTodayAppointmentsCount = isAppointmentsCountersFetched.value
        ? appTodaysWaiting.value
        : appointmentMetrics?.value?.awaitingToday || 0
      const futureAppointmentsCount = isAppointmentsCountersFetched.value
        ? appFutureWaiting.value
        : appointmentMetrics?.value?.future || 0
      return {
        todayAppointmentsCount,
        awaitingTodayAppointmentsCount,
        futureAppointmentsCount
      }
    })

    const availableTableTabs = computed(() => {
      const withoutType = isActiveAppoinmentModule.value ? null : "appointments"
      const withoutValues = activeSchoolHasAppoitmentPasses.value
        ? []
        : ["appointments_awaiting", "appointments_future_awaiting"]
      return state.tableTabs.filter(
        (tab) => tab.type != withoutType && !withoutValues.includes(tab.value)
      )
    })

    watch(
      () => globalTime.value,
      () => {
        store.commit(
          "dashboardCounters/UPDATE_APP_COUNTERS",
          aptPassesCounters.value
        )
      }
    )

    const setActivePassType = (type) => {
      store.commit("dashboardTable/UPDATE_TYPE", type)
      //set deafult value to "active" if user is not in transparency
      if (!isUserInTransparency.value && type == "all") {
        store.commit("dashboardTable/UPDATE_STATUS", "active")
      }
    }

    return {
      state,
      activePassType,
      stats,
      availableTableTabs,
      setActivePassType
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-loading {
  opacity: 0.5;
}
</style>
